// extracted by mini-css-extract-plugin
export default {"rankTitle":"ModalServices_rankTitle__zz3Sz","btn":"ModalServices_btn__3jlsE"};